class WishlistModal extends HTMLElement {
  constructor() {
    super(); 

    this.openModalFor = 3
  }
 
  connectedCallback() {
    window.addEventListener('open-wishlist-modal', (event) => {
      console.log('🚀 -> WishlistModal -> window.addEventListener -> event:', event)
      // render modal
      this.renderModal(event.detail);
    });
  }

  renderModal(details) {
    const { title, image, message } = details;
    console.log('renderModal', { title, image, message })

    // generate HTML
    const modalHtml = `
      <div class="wishlist-modal__inner">
        <div class="wishlist-modal__content">
          <div class="wishlist-modal__image">
            <img src="${image}" alt="${title}">
          </div>
          <div class="wishlist-modal__info">
            <p class="wishlist-modal__title">${title} <span class="wishlist-modal__message">${message}</span></p>
          </div>
        </div>
      </div>
    `;
    this.innerHTML = modalHtml;
    this.classList.add('wishlist-modal--active');

    setTimeout(() => {
      this.deleteModal();
    }, this.openModalFor * 1000);
  }

  deleteModal() {
    this.classList.remove('wishlist-modal--active');
    setTimeout(() => {
      this.innerHTML = '';
    }, 300); // match your animation duration
  }
}

customElements.define('wishlist-modal', WishlistModal);
